import { render, staticRenderFns } from "./edit-contractor-of-transport-company-modal.vue?vue&type=template&id=46e730c6"
import script from "./edit-contractor-of-transport-company-modal.vue?vue&type=script&lang=js"
export * from "./edit-contractor-of-transport-company-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports